angular.module("vgresiduos").factory("supplierService", [
	"$http",
	"accountService",
	"permissionService",
	function ($http, accountService, permissionService) {
		"use strict";

		function _hasSupplierPermission(
			supplier,
			organizationPermission,
			organizationUnitPermission,
			forceHasUnitPermission
		) {
			if (permissionService.hasPermissionV2(Vgr.systemPermissions.SupplierOrganizationMaster)) {
				return true;
			}
			const userResponsibleCode = getSupplierUserResponsibleCode(supplier);
			if (userResponsibleCode) {
				const currentUser = accountService.getLoggedAccount();
				if (userResponsibleCode == currentUser.code) {
					return true;
				} else if (!permissionService.hasPermissionV2(Vgr.systemPermissions.SupplierNotOwnedEdit)) {
					return false;
				}
			}
			if (organizationPermission && permissionService.hasPermissionV2(organizationPermission)) {
				return true;
			}
			if (organizationUnitPermission) {
				return forceHasUnitPermission || hasOrganizationUnitPermission(organizationUnitPermission, supplier);
			}
			return false;
		}

		function hasOrganizationUnitPermission(specificUnitsPermission, supplier) {
			return (
				permissionService.hasPermissionV2(specificUnitsPermission) &&
				supplier.organizationUnitIds.some((unitId) => permissionService.hasAccessToOrganizationUnit(unitId))
			);
		}

		function getSupplierUserResponsibleCode(supplier) {
			if (supplier) {
				if (supplier.UserResponsibleCode) {
					return supplier.UserResponsibleCode;
				}
				if (supplier.userResponsibleCode) {
					return supplier.userResponsibleCode;
				}
			}
			return null;
		}

		function getSupplierApiBaseRequestUrl() {
			const organizationId = accountService.getCurrentClient().organization.id;
			return (
				Vgr.constants.suppliersHostUrl + Vgr.resources.suppliers.suppliers.replace("[ORGANIZATION]", organizationId)
			);
		}

		const _getOrganizationSupplierByCode = function (params) {
			const req = {
				method: "get",
				url: `${getSupplierApiBaseRequestUrl()}code/${params.supplierCode}?includeProfiles=${
					params.includeProfiles ?? false
				}`
			};

			return $http(req);
		};

		function getOrganizationUnitSupplierApiBaseRequestUrl() {
			const currentClient = accountService.getCurrentClient();
			return (
				Vgr.constants.suppliersHostUrl +
				Vgr.resources.suppliers.organizationUnitSuppliers
					.replace("[ORGANIZATION]", currentClient.organization.id)
					.replace("[ORGANIZATION_UNIT]", currentClient.code)
			);
		}

		// PascalCase consumido sem mapeamento pelas telas de destinação. Id repete o Guid porque o textcomplete deduplica a lista por Id.
		function toLegacySupplier(supplier) {
			return {
				Id: supplier.id,
				SupplierId: supplier.id,
				Code: supplier.code,
				Name: supplier.name,
				CNPJ: supplier.document,
				Active: supplier.active,
				CadriEnabled: supplier.cadriEnabled,
				IsTreater: supplier.isDestinator,
				IsTransporter: supplier.isTransporter,
				IsTemporaryStorager: supplier.isTemporaryStorager,
				UserResponsibleCode: supplier.userResponsibleCode,
				City: supplier.city
					? {
							Id: supplier.city.id,
							Description: supplier.city.name,
							State: supplier.city.state
								? {
										Id: supplier.city.state.id,
										Description: supplier.city.state.name,
										Abbreviation: supplier.city.state.abbreviation
								  }
								: null
					  }
					: null
			};
		}

		const _listOrganizationUnitSuppliers = function (params) {
			const req = {
				method: "get",
				url: getOrganizationUnitSupplierApiBaseRequestUrl() + Vgr.util.serializeObjectToQueryString(params)
			};

			return $http(req).then(function (response) {
				return {
					...response,
					data: {
						Suppliers: response.data.map(toLegacySupplier),
						Count: Number(response.headers("X-Total-Count"))
					}
				};
			});
		};

		return {
			listOrganizationUnitSuppliers: _listOrganizationUnitSuppliers,
			hasSupplierPermission: _hasSupplierPermission,
			getOrganizationSupplierByCode: _getOrganizationSupplierByCode
		};
	}
]);
